var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Flex, Grid, Relative, ShadowOverlay, Text } from 'pcln-design-system';
import InputModal from '@pcln/input-modal';
import { themeGet } from '@styled-system/theme-get';
import Calendar from '../Calendar';
import DateField from '../DateField';
import formatDates from '../utils/formatDates';
import getLengthOfStay from '../utils/getLengthOfStay';
var StyledCalendar = /*#__PURE__*/styled(Calendar).withConfig({
  displayName: "DatePicker__StyledCalendar",
  componentId: "sc-8yne6i-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    position: ", ";\n    ", "\n    z-index: ", ";\n    margin-top: ", ";\n  }\n"], ["\n  &&& {\n    position: ", ";\n    ", "\n    z-index: ", ";\n    margin-top: ", ";\n  }\n"])), function (props) {
  return props.position || 'absolute';
}, function (_a) {
  var rightAlignCalendar = _a.rightAlignCalendar;
  return rightAlignCalendar && 'right: 0;';
}, function (props) {
  return props.zIndex;
}, themeGet('space.2'));
var StyledShadowOverlay = /*#__PURE__*/styled(ShadowOverlay).withConfig({
  displayName: "DatePicker__StyledShadowOverlay",
  componentId: "sc-8yne6i-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    ", "\n  }\n"], ["\n  &&& {\n    ", "\n  }\n"])), function (props) {
  return props.hide && 'background-color: transparent;';
});
var StyledHeader = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "DatePicker__StyledHeader",
  componentId: "sc-8yne6i-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &&& {\n    align-items: center;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: fit-content;\n    width: 100%;\n    padding-top: ", ";\n  }\n"], ["\n  &&& {\n    align-items: center;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: fit-content;\n    width: 100%;\n    padding-top: ", ";\n  }\n"])), themeGet('space.2'));
var defaultInitialDates = {
  startDate: null,
  endDate: null
};
function DatePicker(_a) {
  var borderColor = _a.borderColor,
    dateTextColor = _a.dateTextColor,
    iconColor = _a.iconColor,
    className = _a.className,
    disabled = _a.disabled,
    errorMessage = _a.errorMessage,
    _b = _a.hasShadowEffect,
    hasShadowEffect = _b === void 0 ? true : _b,
    height = _a.height,
    _c = _a.initialDates,
    initialDates = _c === void 0 ? defaultInitialDates : _c,
    isInitiallyOpen = _a.isInitiallyOpen,
    isMobile = _a.isMobile,
    _d = _a.label,
    label = _d === void 0 ? 'Check-in - Check-out' : _d,
    name = _a.name,
    noDateLabel = _a.noDateLabel,
    preventLabelWrap = _a.preventLabelWrap,
    rightAlignCalendar = _a.rightAlignCalendar,
    _e = _a.selectTwoDates,
    selectTwoDates = _e === void 0 ? true : _e,
    showLengthOfStayCopy = _a.showLengthOfStayCopy,
    use2024DesignSeti = _a.use2024DesignSeti,
    width = _a.width,
    _f = _a.zIndex,
    zIndex = _f === void 0 ? 2 : _f,
    onBlur = _a.onBlur,
    onChange = _a.onChange,
    onToggle = _a.onToggle,
    onFocus = _a.onFocus,
    calendarProps = __rest(_a, ["borderColor", "dateTextColor", "iconColor", "className", "disabled", "errorMessage", "hasShadowEffect", "height", "initialDates", "isInitiallyOpen", "isMobile", "label", "name", "noDateLabel", "preventLabelWrap", "rightAlignCalendar", "selectTwoDates", "showLengthOfStayCopy", "use2024DesignSeti", "width", "zIndex", "onBlur", "onChange", "onToggle", "onFocus"]);
  var _g = useState(isInitiallyOpen),
    isOpen = _g[0],
    setOpen = _g[1];
  var _h = useState(initialDates),
    dates = _h[0],
    setDates = _h[1];
  useEffect(function () {
    setOpen(isInitiallyOpen);
  }, [isInitiallyOpen]);
  var hideTooltip = useMemo(function () {
    return (calendarProps === null || calendarProps === void 0 ? void 0 : calendarProps.hideTooltip) || isOpen;
  }, [calendarProps.hideTooltip, isOpen]);
  var dateString = useMemo(function () {
    return formatDates(selectTwoDates, dates);
  }, [selectTwoDates, dates]);
  useEffect(function () {
    setDates(initialDates);
  }, [initialDates]);
  var handleOpen = useCallback(function () {
    onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    setOpen(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus();
  }, [onFocus]);
  var handleFocus = useCallback(function () {
    if (!disabled && !isMobile) {
      setOpen(true);
      onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }
  }, [disabled, isMobile, onFocus]);
  var handleClose = useCallback(function () {
    onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    setOpen(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur();
  }, [dates, onBlur, onChange, onToggle]);
  var handleChange = useCallback(function (evt, dates) {
    setDates(dates);
    if ((dates === null || dates === void 0 ? void 0 : dates.endDate) !== null) {
      onToggle === null || onToggle === void 0 ? void 0 : onToggle();
      handleClose();
      onChange === null || onChange === void 0 ? void 0 : onChange(dates);
    }
  }, [dates, handleClose]);
  var lengthOfStayCopy = getLengthOfStay(dates === null || dates === void 0 ? void 0 : dates.startDate, dates === null || dates === void 0 ? void 0 : dates.endDate);
  return React.createElement(Relative, null, isOpen && !isMobile && React.createElement(StyledShadowOverlay, {
    hide: !hasShadowEffect,
    zIndex: zIndex,
    onClick: handleClose,
    "data-testid": 'date-picker-overlay'
  }), React.createElement(DateField, {
    className: className,
    disabled: disabled,
    dateTextColor: dateTextColor,
    error: errorMessage,
    height: height,
    hideTooltip: hideTooltip,
    borderColor: borderColor,
    iconColor: iconColor,
    isMobile: isMobile,
    label: label,
    name: name,
    noDateLabel: noDateLabel,
    preventLabelWrap: preventLabelWrap,
    value: showLengthOfStayCopy && lengthOfStayCopy ? "".concat(dateString, " ").concat(lengthOfStayCopy) : dateString,
    width: width,
    zIndex: isOpen ? zIndex : 0,
    onClick: handleOpen,
    onFocus: handleFocus
  }), isOpen && !isMobile && React.createElement(StyledCalendar, __assign({
    zIndex: zIndex + 1,
    rightAlignCalendar: rightAlignCalendar,
    selectTwoDates: selectTwoDates,
    startDate: dates === null || dates === void 0 ? void 0 : dates.startDate,
    endDate: dates === null || dates === void 0 ? void 0 : dates.endDate,
    use2024DesignSeti: use2024DesignSeti,
    onChange: handleChange,
    onDismiss: handleClose
  }, calendarProps)), isMobile && React.createElement(InputModal, {
    footer: use2024DesignSeti && React.createElement(Button, {
      size: 'large',
      variation: 'fill',
      onClick: handleClose
    }, "Select Dates ", getLengthOfStay(dates === null || dates === void 0 ? void 0 : dates.startDate, dates === null || dates === void 0 ? void 0 : dates.endDate)),
    id: 'date-picker-modal',
    isOpen: isOpen,
    input: use2024DesignSeti ? React.createElement(Grid, {
      alignItems: 'flex-start',
      templateColumns: '1fr auto'
    }, React.createElement(StyledHeader, {
      "aria-label": 'Choose Travel Dates'
    }, React.createElement(Text, {
      fontSize: '3',
      fontWeight: 'bold',
      color: 'primary.dark',
      mb: 3
    }, "Choose Dates")), React.createElement(Box, {
      width: '40px',
      height: '40px',
      ml: '12px'
    })) : React.createElement(DateField, {
      error: errorMessage,
      hideTooltip: hideTooltip,
      isMobile: true,
      label: label,
      name: name,
      preventLabelWrap: preventLabelWrap,
      value: showLengthOfStayCopy && lengthOfStayCopy ? "".concat(dateString, " ").concat(lengthOfStayCopy) : dateString,
      width: 1
    }),
    inputProps: use2024DesignSeti ? {
      alignItems: 'flex-start',
      px: 2,
      py: 2
    } : {
      alignItems: 'center',
      px: '12px',
      py: '12px'
    },
    subheading: use2024DesignSeti && React.createElement(Flex, {
      justifyContent: 'center',
      width: '100%'
    }, React.createElement(Text, {
      fontSize: '2',
      fontWeight: 'medium',
      color: 'text',
      mb: 2
    }, dateString ? "".concat(dateString, " ").concat(lengthOfStayCopy) : label)),
    zIndex: zIndex,
    onClose: handleClose
  }, React.createElement(Calendar, __assign({
    startDate: dates === null || dates === void 0 ? void 0 : dates.startDate,
    endDate: dates === null || dates === void 0 ? void 0 : dates.endDate,
    isMobile: true,
    selectTwoDates: selectTwoDates,
    use2024DesignSeti: use2024DesignSeti,
    onChange: handleChange,
    onDismiss: handleClose
  }, calendarProps))));
}
export default memo(DatePicker);
var templateObject_1, templateObject_2, templateObject_3;